import AmisAPI from '@/api/AmisAPI.js';
import httpClient from '../../api/axios-httpclient';
import { MSEnum } from '@/common/enumeration';

export default {
	/**
	 * Lấy danh sách tenant công ty cho popup Chọn dữ liệu công ty
	 * API do PBI 386427 implement
	 */
	getAmisTenants: async function(context, payload) {
		try {
			let res = await httpClient.getAsync({
				url: AmisAPI.getAPIUrl() + '/tenants',
				params: payload
			});

			if (res && res.Success) {
				return res.Data;
			}

			return null;
		} catch (ex) {
			console.error('getAmisTenants::exception', ex);
			return null;
		}
	},

	/**
	 * Kích hoạt nâng cấp AMIS Convert theo công ty AMIS đã chọn
	 * API /api/amis/amis-convert (AmisController.ConvertAmisTenantAsync)
	 * Thành công → chỉ đánh dấu AmisConvertStatus = Processing vào module taxpayerinfo
	 * (state đơn nguồn), không điều khiển UI — App.vue tự xử lý qua direct-call.
	 */
	activateAmisConvert: async function(context, payload) {
		try {
			let res = await httpClient.postAsync(
				{
					url: AmisAPI.getAPIUrl() + '/amis-convert',
					data: payload
				},
				true
			);

			if (res && res.Success) {
				context.commit(
					'taxpayerinfo/updateAmisConvertStatus',
					MSEnum.AmisConvertStatus.Processing,
					{ root: true }
				);
			}

			return res;
		} catch (ex) {
			console.error('activateAmisConvert::exception', ex);
			return null;
		}
	}
};
